module.exports = __webpack_public_path__ + "img/Edit(Button).8ae47b76.svg";